// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"272":"admin-login","594":"about","884":"admin"}[chunkId] + "." + {"272":"1d6790b0","594":"5c15462a","884":"5d81da75"}[chunkId] + ".css";
};